export const REG_EXP_NUMBER = /^-?\d+(\.\d+)?$/;
